/**
 * True when the logged-in user is a Meraki administrator: the Meraki - Operations account
 * signed in with an admin login (bunge username, PIC or sub-username containing "admin").
 */
export function isMerakiAdminUser(): boolean {
  const username = localStorage.getItem('username') ?? '';
  if (username !== 'Meraki - Operations') return false;

  const bungeKey = String(localStorage.getItem('bungeUsername') ?? '').toLowerCase();
  const picKey = String(localStorage.getItem('loginPic') ?? '').toLowerCase();
  const subKey = String(localStorage.getItem('subUsername') ?? '').toLowerCase();

  return (
    bungeKey === 'meraki_superadmin' ||
    bungeKey === 'meraki_admin' ||
    bungeKey === 'meraki_sosa' ||
    bungeKey === 'meraki_gusi' ||
    bungeKey.includes('admin') ||
    picKey.includes('admin') ||
    picKey === 'sosa' ||
    picKey === 'gusi' ||
    subKey.includes('admin') ||
    subKey === 'sosa' ||
    subKey === 'gusi'
  );
}
